/* eslint-disable max-len */
import { LogicCondition, PropertyCondition, ObjectizerModel, ExpressionCondition } from '@leverege/condition';
import LogicConditionEditor from "./logic/LogicConditionEditor.js";
import PropertyConditionEditor from "./property/PropertyConditionEditor.js";
import ExpressionConditionEditor from "./expression/ExpressionConditionEditor.js";
import ObjectizerEditor from "./objectizer/ObjectizerEditor.js";
import ReplaceConditionAction from "./objectizer/actions/ReplaceConditionAction.js";
import ReplaceLogicConditionAction from "./logic/actions/ReplaceConditionAction.js";
import RemoveRuleAction from "./objectizer/actions/RemoveRuleAction.js";
import DuplicateRuleAction from "./objectizer/actions/DuplicateRuleAction.js";
import RemoveConditionAction from "./logic/actions/RemoveConditionAction.js";
import DuplicateConditionAction from "./logic/actions/DuplicateConditionAction.js";
import DragGrabberAction from "./logic/actions/DragGrabberAction.js";
import NestConditionAction from "./logic/actions/NestConditionAction.js";
import CopyRuleAction from "./objectizer/actions/CopyRuleAction.js";
import PasteRuleAction from "./objectizer/actions/PasteRuleAction.js";
export default {
  install(plg) {
    plg.addPlugin('ModelEditor', {
      type: LogicCondition.TYPE,
      editor: LogicConditionEditor
    });
    plg.addPlugin('ModelEditor', {
      type: PropertyCondition.TYPE,
      editor: PropertyConditionEditor
    });
    plg.addPlugin('ModelEditor', {
      type: ObjectizerModel.TYPE,
      editor: ObjectizerEditor
    });
    plg.addPlugin('ModelEditor', {
      type: ExpressionCondition.TYPE,
      editor: ExpressionConditionEditor
    });
    plg.addPlugin('Action', ReplaceConditionAction);
    plg.addPlugin('Action', RemoveRuleAction);
    plg.addPlugin('Action', DuplicateRuleAction);
    plg.addPlugin('Action', CopyRuleAction);
    plg.addPlugin('Action', PasteRuleAction);
    plg.addPlugin('Action', RemoveConditionAction);
    plg.addPlugin('Action', DuplicateConditionAction);
    plg.addPlugin('Action', NestConditionAction);
    plg.addPlugin('Action', ReplaceLogicConditionAction);
    plg.addPlugin('Action', DragGrabberAction);
  }
};